import * as React from 'react';
import { V3Routes } from '../../../routes';
import { Link } from 'react-router-dom';
import './cancellationPolicy.module.scss';

export const CancellationPolicy = () => (
    <div styleName="cancellation-policy">
        <div styleName="header">キャンセルについて</div>
        <ul styleName="body">
            <li>
                キャンセルの場合は<span styleName="red">前日までに</span>必ず
                <Link to={V3Routes.reservations()} styleName="link">
                    マイページ
                </Link>からご自身でキャンセルをお願いします。
            </li>
            <li>当日無断キャンセルをされた場合は、その後2ヶ月ご予約が出来なくなりますのでご注意下さい。</li>
        </ul>
    </div>
);
